import { useFirestore, useFirestoreGeneralOrderBy, useFirestoreOrderBy } from "../../firebase/useFirestore";
import ScrollToTop from "../../hooks/ScrollToTop";
import useSettings from "../../hooks/Settings";
import { useHistory } from "react-router-dom";
import { client } from "../../hooks/Client";
import Tooltip from "../../components/common/Tooltip";
import DeleteModal from "../../components/common/DeleteModal";
import { SavedIcon } from "../../StateManagment/SavedIcon";
import { Auth } from "../../StateManagment/Auth";
import uuid from "react-uuid";
import { db, timestamp } from "../../firebase/config";
import { useState, useEffect, useContext } from "react";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined'
import CopyLink from "../../components/common/CopyLink";
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import PremiumContainer from "../../components/common/PremiumContainer";
import Table from "../../components/common/table/Table.jsx";
import TableTitleCell from "../../components/common/table/TableTitleCell.jsx";
import ReadOnlyGuard from "../../components/common/ReadOnlyGuard";

const LiveReports = () => {
    // Context
    const [saved, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)

    // State
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteDocid, setDeleteDocid] = useState('123')
    const [deleteName, setDeleteName] = useState('')
    const [defaultStartDate, setDefaultStartDate] = useState(null)
    const [dragArray, setDragArray] = useState([]);

    // Hooks
    ScrollToTop()
    const subscription = useSettings().subscription
    const history = useHistory()

    // Firestore
    const allReports = useFirestore("LiveReports");
    const reports =  allReports && allReports.filter(item => item.Version === 2)
    const oldReports = allReports && allReports.filter(item => item.Version !== 2)
    const compagny = useFirestore("CompagnyMeta")
    const noTemplateReports = reports && reports.filter(item => !item.Template)


    // Whenever Firestore data changes, update dragArray state
    useEffect(() => {
        // setDragArray(noTemplateReports);
    }, [noTemplateReports]);

    // DRAG & DROP: reorder items and update Firestore
    const handleDragEnd = (result) => {
        if (!result.destination) return;
    
        const items = Array.from(dragArray);
        const [movedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, movedItem);
    
        // Update local state to reflect the reorder immediately
        setDragArray(items);
    
        // Now update Firestore with new positions
        items.forEach((item, idx) => {
          db.collection('LiveReports')
            .doc(item.docid) // assuming .docid is stored for each doc
            .update({ Position: idx + 1 });
        });
    
        // Show "saved" icon
        setSaved('flex');
      };

    // Formatted date
    const formatDate = (date) => {
        if (!date) return null; // Handle null or undefined dates
        const isoDate = date.toISOString().split('T')[0]; // Extract yyyy-mm-dd
        const [year, month, day] = isoDate.split('-'); // Destructure into parts
        return `${day}-${month}-${year}`; // Return formatted date
      }

    // Set the default start date as the date the compagny profile was created
    const findDefaultStartDate = () => {

        compagny && compagny.forEach(item => {
            setDefaultStartDate(item.Timestamp)
        })
    }

    useEffect(() => {
        findDefaultStartDate()
    },[compagny])

    const addReport = () => {
        history.push(`/${client}/livereports2`);
    }

     // Delete modal 
     const deleteModalHandler = (e) => {
        const docid = e.currentTarget.dataset.docid
        const deleteName = e.currentTarget.dataset.deletename

        setDeleteDocid(docid)
        setDeleteName(deleteName)

        setDeleteModal(!deleteModal)
    }


    const deleteReport = (e) => {

        db.collection('LiveReports')
        .doc(deleteDocid)
        .delete()
    }

    const titleHandler = (e) => {
        const docid = e.target.dataset.docid
        const title = e.target.value

        db.collection('LiveReports')
        .doc(docid)
        .update({
            Title: title
        })
        .then(() =>{
            setSaved(true)
        })
    }

    const tableColumns = [
        { key: 'drag', label: '', searchable: false },
        { key: 'title', label: 'TITEL' },
        { key: 'period', label: 'PERIODE', searchable: false },
        { key: 'link', label: 'LINK', searchable: false },
        { key: 'print', label: 'PRINT', searchable: false },
        { key: 'delete', label: 'VERWIJDEREN', searchable: false },
    ]

    return (
        <div className="main">
        <div className="main-container">
            <div className='page-header'>
                <h1>Live rapportages</h1>
            </div>
            <ReadOnlyGuard edit="reports.edit">
                {(canEdit) => (
                    <Table
                        columns={tableColumns}
                        items={dragArray || []}
                        getItemKey={(item) => item.ID}
                        renderRow={(item) => (
                            <>
                                <td>
                                    <DragIndicatorOutlinedIcon />
                                </td>
                                <TableTitleCell
                                    value={item.Title}
                                    to={`/${client}/livereportbuilder/${item.ID}`}
                                    onBlur={titleHandler}
                                    docid={item.docid}
                                    placeholder='Noteer hier de externe factor'
                                />
                                <td>
                                    <div id='live-reports-overview-date-range-container'>
                                        <p>{item.Start ? formatDate(item.Start.toDate()) : 'Alles'}</p>
                                        <p>-</p>
                                        <p>{item.End ? formatDate(item.End.toDate()) : 'Alles'}</p>
                                    </div>
                                </td>
                                <td>
                                    <CopyLink link={`/${client}/livereportopen/${item.ID}/open`}/>
                                </td>
                                <td>
                                    <Tooltip content={'Print liverapport'} width='100%' top='-60px'>
                                        <PrintOutlinedIcon className='table-delete-icon' onClick={() => window.open(`/${client}/printlivereport/${item.ID}`, '_blank')}/>
                                    </Tooltip>
                                </td>
                                <td>
                                    {canEdit && (
                                        <Tooltip content={'Liverapport verwijderen'} width='100%' top='-60px'>
                                            <DeleteOutlinedIcon className='table-delete-icon' data-docid={item.docid} data-deletename={item.Title} onClick={deleteModalHandler} />
                                        </Tooltip>
                                    )}
                                </td>
                            </>
                        )}
                        searchAccessor={(item) => item.Title}
                        searchPlaceholder="Zoeken op titel"
                        emptyMessage="Geen live rapportages gevonden."
                        draggable={true}
                        droppableId="reports"
                        onDragEnd={handleDragEnd}
                        addRow={canEdit ? {
                            toolTipContent: 'Live-rapportage toevoegen',
                            onClick: addReport,
                        } : undefined}
                    />
                )}
            </ReadOnlyGuard>
        </div>
        <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteItem={deleteReport} deleteName={deleteName} />
    </div>
  );
};

export default LiveReports;
